<div class="container-fluid p-0" id="dashboard">
  <div class="maintenance-content">
    <div class="px-0 px-md-3">
      <div class="w-100">
        <section class="col-sm-12 px-md-1">
          <div class="row my-4">
            <div class="col-lg-6 mb-4">
              <mat-expansion-panel class="alert-panel" [expanded]="true" disabled>
                <mat-expansion-panel-header>
                  <mat-panel-title
                    ><h5 class="mb-0">Alerts</h5>
                    <button
                      mat-button
                      color="primary"
                      (click)="openManageMaintenancePopup()"
                      class="button"
                      class="float-right"
                    >
                      <b>Manage Alerts</b>
                    </button></mat-panel-title
                  >
                </mat-expansion-panel-header>
                <mat-tab-group class="mat_tab alert_tab">
                  <mat-tab label="All" color="primary" class="mat-tab-label-active">
                    <div class="row py-3 alert">
                      <div class="col-md-1 col-1">
                        <mat-checkbox></mat-checkbox>
                      </div>
                      <div class="col-md-8 col-10 pl-md-0 pl-2">
                        Scheduled message alerts are notifications that are set to be sent or received at a specific
                        time or date. They can be used for reminders, updates, or important announcements
                      </div>
                      <div class="col-md-3"><div class="date">Mar 2, 2024</div></div>
                    </div>
                    <div class="row py-3 alert">
                      <div class="col-md-1 col-1">
                        <mat-checkbox></mat-checkbox>
                      </div>
                      <div class="col-md-8 col-10 pl-md-0 pl-2">
                        Scheduled message alerts are notifications that are set to be sent or received at a specific
                        time or date. They can be used for reminders, updates, or important announcements
                      </div>
                      <div class="col-md-3"><div class="date">Mar 2, 2024</div></div>
                    </div>
                    <div class="row py-3 alert">
                      <div class="col-md-1 col-1">
                        <mat-checkbox></mat-checkbox>
                      </div>
                      <div class="col-md-8 col-10 pl-md-0 pl-2">
                        Scheduled message alerts are notifications that are set to be sent or received at a specific
                        time or date. They can be used for reminders, updates, or important announcements
                      </div>
                      <div class="col-md-3"><div class="date">Mar 2, 2024</div></div>
                    </div>
                    <div class="row py-3 alert">
                      <div class="col-md-1 col-1">
                        <mat-checkbox></mat-checkbox>
                      </div>
                      <div class="col-md-8 col-10 pl-md-0 pl-2">
                        Scheduled message alerts are notifications that are set to be sent or received at a specific
                        time or date. They can be used for reminders, updates, or important announcements
                      </div>
                      <div class="col-md-3"><div class="date">Mar 2, 2024</div></div>
                    </div>

                    <!-- <app-followed-properties-card-view></app-followed-properties-card-view> -->
                  </mat-tab>

                  <mat-tab label="Pending">
                    <div class="row py-3 alert">
                      <div class="col-md-1 col-1">
                        <mat-checkbox></mat-checkbox>
                      </div>
                      <div class="col-md-8 col-10 pl-md-0 pl-2">
                        Scheduled message alerts are notifications that are set to be sent or received at a specific
                        time or date. They can be used for reminders, updates, or important announcements
                      </div>
                      <div class="col-md-3"><div class="date">Mar 2, 2024</div></div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Completed">
                    <div class="row py-3 alert">
                      <div class="col-md-1 col-1">
                        <mat-checkbox></mat-checkbox>
                      </div>
                      <div class="col-md-8 col-10 pl-md-0 pl-2">
                        Scheduled message alerts are notifications that are set to be sent or received at a specific
                        time or date. They can be used for reminders, updates, or important announcements
                      </div>
                      <div class="col-md-3"><div class="date">Mar 2, 2024</div></div>
                    </div>
                  </mat-tab>
                </mat-tab-group>
              </mat-expansion-panel>
              <!-- <div class="card-item">
                <h5>Alerts</h5>
                <button
                  mat-button
                  color="primary"
                  (click)="openManageMaintenancePopup()"
                  class="button"
                  class="float-right"
                >
                  <b>Manage Alerts</b>
                </button>
                <mat-tab-group class="mat_tab property_tab">
                  <mat-tab label="All" color="primary" class="mat-tab-label-active">
                    <mat-checkbox>
                      Scheduled message alerts are notifications that are set to be sent or received at a specific time
                      or date. They can be used for reminders, updates, or important announcements</mat-checkbox
                    >
                    <mat-checkbox>
                      Scheduled message alerts are notifications that are set to be sent or received at a specific time
                      or date. They can be used for reminders, updates, or important announcements</mat-checkbox
                    >
                    <mat-checkbox>
                      Scheduled message alerts are notifications that are set to be sent or received at a specific time
                      or date. They can be used for reminders, updates, or important announcements</mat-checkbox
                    >
                  </mat-tab>

                  <mat-tab label="Pending">
                    <mat-checkbox color="primary">
                      <span
                        >Scheduled message alerts are notifications that are set to be sent or received at a specific
                        time or date. They can be used for reminders, updates, or important announcements</span
                      ></mat-checkbox
                    >
                  </mat-tab>
                  <mat-tab label="Completed">
                    <mat-checkbox color="primary">
                      <span style="text-decoration: line-through"
                        >This is to inform you that the scheduled maintenance has been completed and the status is now
                        closed.</span
                      >
                    </mat-checkbox>

                    <mat-checkbox color="primary">
                      <span style="text-decoration: line-through"
                        >This is to inform you that the scheduled maintenance has been completed and the status is now
                        closed.</span
                      >
                    </mat-checkbox>
                    <mat-checkbox color="primary">
                      <span style="text-decoration: line-through"
                        >This is to inform you that the scheduled maintenance has been completed and the status is now
                        closed.</span
                      >
                    </mat-checkbox>
                    <mat-checkbox color="primary">
                      <span style="text-decoration: line-through"
                        >This is to inform you that the scheduled maintenance has been completed and the status is now
                        closed.</span
                      > </mat-checkbox
                    ><mat-checkbox color="primary">
                      <span style="text-decoration: line-through"
                        >This is to inform you that the scheduled maintenance has been completed and the status is now
                        closed.</span
                      >
                    </mat-checkbox>
                  </mat-tab>
                </mat-tab-group>
              </div> -->
            </div>

            <div class="col-lg-6 mb-4">
              <mat-expansion-panel class="alert_tab" [expanded]="true" disabled>
                <mat-expansion-panel-header>
                  <mat-panel-title
                    ><h5 class="mb-0">Maintenance History</h5>
                    <button
                      mat-button
                      color="primary"
                      (click)="openManageMaintenancePopup()"
                      class="button"
                      class="float-right"
                    >
                      <b>Dowbload</b>
                    </button></mat-panel-title
                  >
                </mat-expansion-panel-header>
                <div class="timeline-container">
                  <div class="timeline-item">
                    <div class="timeline-p">
                      <div class="timeline-item-content">
                        <h4>HVAC Maintenance</h4>
                        <div class="transaction-details">
                          <div>Annual HVAC Maintenance checkup and filters</div>
                          <div class="service">Service Provider HAV heating</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="timeline-item">
                    <div class="timeline-p">
                      <div class="timeline-item-content">
                        <h4>HVAC Maintenance</h4>
                        <div class="transaction-details">
                          <div>Annual HVAC Maintenance checkup and filters</div>
                          <div class="service">Service Provider HAV heating</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="timeline-item">
                    <div class="timeline-p">
                      <div class="timeline-item-content">
                        <h4>HVAC Maintenance</h4>
                        <div class="transaction-details">
                          <div>Annual HVAC Maintenance checkup and filters</div>
                          <div class="service">Service Provider HAV heating</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
              <!-- <h5>Maintenance History</h5>
              <div class="timeline-container">
                <div class="timeline-item">
                  <div class="timeline-p">
                    <div class="timeline-item-content">
                      <h4>HVAC Maintenance</h4>
                      <div class="transaction-details">
                        <div>Annual HVAC Maintenance checkup and filters</div>
                        <div>Service Provider HAV heating</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
